<template>
    <div class="footer">
        <!-- <div class="foot_head">
            <div
                v-for="(item, index) in footList"
                :key="index"
                class="head_item"
            >
                <img :src="item.url" style="width: 50px; height: 50px" />
                <div class="item_right">
                    <h2>{{ item.title }}</h2>
                </div>
            </div>
        </div> -->
        <div class="foot_content">
            <div class="footer-block">
                <ul style="list-style: none">
                    <p class="footer-title">
                        关于我们
                    </p>
                    <li
                        @click="enterProDetail('http://www.nbhuojian.com/')"
                    >
                        公司简介
                    </li>
                    <!-- <li
                        @click="enterProDetail('http://www.nbhuojian.com/#/company_state')"
                    >
                        最新动态
                    </li> -->
                </ul>
            </div>
            <div class="footer-block">
                <div>
                    <p class="footer-title">联系我们</p>
                    <div class="foot_touch_list">
                        <div class="foot_touch_item" v-for="item in contactList" :key="item.phone">
                            <div class="foot_touch_item_phone">
                                <el-image
                                    :src="mobileIcon"
                                    lazy
                                    style="width: 20px; height: 20px"
                                ></el-image>
                                <el-tooltip content="点击复制" placement="top">
                                    <span class="foot_touch_text" v-clipboard:copy="item.phone" v-clipboard:success="handleCopySuccess">
                                        {{ item.phone }}
                                    </span>
                                </el-tooltip>
                            </div>
                            <div class="qr-wrapper">
                                <el-image
                                    :src="item.qrcodeUrl"
                                    lazy
                                    class="foot_touch_qrcode qr-code"
                                    :preview-src-list="[item.qrcodeUrl]"
                                ></el-image>
                                <div class="qr-hint">
                                    <i class="el-icon-zoom-in"></i>
                                    <span>点击查看大图</span>
                                </div>
                            </div>
                            <div class="foot_touch_item_name">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-block">
                <ul style="list-style: none">
                    <p class="footer-title">
                        公司产品
                    </p>
                    <li>F1接单输单系统</li>
                    <li>单证中心</li>
                    <li>放舱网</li>
                </ul>
            </div>
            <div class="footer-block">
                <div
                    style="display: flex; flex-direction: column; align-items: center;"
                >
                    <p class="footer-title">欢迎关注订阅放舱网</p>
                    <div class="weixin">
                        <div class="qr-wrapper">
                            <el-image
                                :src="qrCodeFirst"
                                lazy
                                class="qr_img qr-code"
                                :preview-src-list="[qrCodeFirst]"
                            ></el-image>
                            <div class="qr-hint">
                                <i class="el-icon-zoom-in"></i>
                                <span>点击查看大图</span>
                            </div>
                        </div>
                        <div class="qr-wrapper">
                            <el-image
                                :src="qrCodeSecond"
                                lazy
                                class="qr_img qr-code"
                                :preview-src-list="[qrCodeSecond]"
                            ></el-image>
                            <div class="qr-hint">
                                <i class="el-icon-zoom-in"></i>
                                <span>点击查看大图</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-record">
            <span>火箭数据科技有限公司</span>
            <el-divider direction="vertical" />
            <a
                href="https://www.beian.gov.cn/portal/registerSystemInfo?spm=a21bo.jianhua.1997523009.39.5af92a89VpB9nV&recordcode=33021202002094"
                class="footer-line"
            >
                <span class="footer-info">浙公网安备 33021202002094号</span>
            </a>
            <el-divider direction="vertical" />
            <a href="https://beian.miit.gov.cn/" class="footer-line">
                <span class="footer-info">浙ICP备2022012639号-1</span>
            </a>
            <el-divider direction="vertical" />
            <span class="footer-info" >版本信息：v{{ version }}</span>
        </div>
    </div>
</template>

<script>
import { version } from '../../../../package.json';
export default {
    data() {
        return {
            version,
            qrCodeFirst: require("@/assets/qq_.png"),
            qrCodeSecond: require("@/assets/img/mainPageImg/qrCodeSecond.png"),
            phoneIcon: require("@/assets/img/mainPageImg/phoneIcon.png"),
            mobileIcon: require("@/assets/img/mainPageImg/mobileIcon.png"),
            contactList: [
                {
                    qrcodeUrl: 'https://web.nbhuojian.com/static/fangcangwang/customer-service/zhr.jpg',
                    name: '郑经理',
                    phone: '15268426646'
                },
                // {
                //     qrcodeUrl: 'https://web.nbhuojian.com/static/fangcangwang/customer-service/ljl.jpg',
                //     name: '李经理',
                //     phone: '19518565275'
                // },
                {
                    qrcodeUrl: 'https://web.nbhuojian.com/static/fangcangwang/customer-service/xcm.jpg',
                    name: '徐经理',
                    phone: '18644079547'
                },
                {
                    qrcodeUrl: 'https://web.nbhuojian.com/static/fangcangwang/customer-service/nkc.jpg',
                    name: '倪经理',
                    phone: '13157331003'
                }
            ],
            footList: [
                {
                    url: require("@/assets/img/mainPageImg/footIconFirst.png"),
                    title: "多渠道服务支持",
                },
                {
                    url: require("@/assets/img/mainPageImg/footIconSecond.png"),
                    title: "产品持续迭代",
                },
                {
                    url: require("@/assets/img/mainPageImg/footIconThree.png"),
                    title: "安全数据环境",
                },
            ],
        }
    },
    methods: {
        enterProDetail(url) {
            window.open(url, "_blank");
        },
        handleCopySuccess() {
            this.$message.success('复制成功');
        },
    },
}
</script>
<style lang="stylus" scoped>
.footer {
    background: #414755;
    font-size: 13px;
    color: #fff;
    position: relative;
    width: 100%;
    // 二维码样式
    .qr-wrapper {
        position: relative;
        display: inline-block;
    }
    .qr-code {
        width: 80px;
        height: 80px;
        border-radius: 6px;
        background: #fff;
        box-shadow: 0 1px 4px rgba(0,0,0,0.06);
        transition: transform 0.3s ease;
        cursor: pointer;
    }
    .qr-code:hover {
        transform: scale(1.05);
    }
    .qr-hint {
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(0, 0, 0, 0.7);
        color: #fff;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 11px;
        white-space: nowrap;
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
        z-index: 2;
    }
    .qr-wrapper:hover .qr-hint {
        opacity: 1;
    }
    .qr-hint i {
        margin-right: 4px;
        font-size: 10px;
    }
    // 移除max-width、margin、圆角、阴影
    .foot_touch_list{
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 24px;
        flex-wrap: wrap;
        margin-bottom: 10px;
        .foot_touch_item{
            display: flex;
            flex-direction: column;
            align-items: center;
            background: rgba(255,255,255,0.03);
            border-radius: 8px;
            padding: 10px 16px 12px 16px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.04);
            transition: box-shadow 0.2s;
            &:hover {
                box-shadow: 0 4px 16px rgba(0,153,255,0.10);
            }
        }
        .foot_touch_item_phone{
            display: flex;
            align-items: center;
            margin-bottom: 8px;
        }
        .foot_touch_qrcode{
            width: 90px;
            height: 110px;
            margin-top: 4px;
            border-radius: 6px;
            background: #fff;
            box-shadow: 0 1px 4px rgba(0,0,0,0.06);
        }
        .foot_touch_item_name{
            margin-top: 8px;
            font-size: 12px;
        }
    }
    .foot_head {
      margin: auto;
      display: flex;
      justify-content: space-around;
      background-color: #1e282d;
      box-sizing: border-box;
      .head_item {
        width: 23%;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        .item_right {
          display: flex;
          flex-direction: column;
          color: white;
          margin-left: 10px;
          h2 {
            font-size: 14px;
            font-weight: 400;
          }
          p {
            margin-top: 8px;
            font-size: 10px;
          }
        }
      }
      .head_item:hover {
        background-color: rgb(36, 35, 35);
      }
    }
    .foot_content {
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      padding: 24px 40px 0 40px;
      gap: 0;
      .footer-block {
        padding: 0 12px;
        flex-grow:0;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .footer-title{
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 18px;
        letter-spacing: 1px;
      }
      ul {
        padding: 0;
        margin: 0;
      }
      ul li {
        margin-top: 12px;
        transition: color 0.2s;
        cursor: pointer;
      }
      ul li:hover {
        color: #0099ff;
      }
      .foot_touch_text{
        margin-left: 6px;
        cursor: pointer;
        transition: color 0.3s;
        font-weight: 500;
        &:hover {
          color: #0099ff;
        }
      }
      .weixin {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        gap: 32px;
        .qr-wrapper {
            position: relative;
            display: inline-block;
        }
        .qr-code {
            width: 80px;
            height: 80px;
            border-radius: 6px;
            background: #fff;
            box-shadow: 0 1px 4px rgba(0,0,0,0.06);
            transition: transform 0.3s ease;
            cursor: pointer;
        }
        .qr-code:hover {
            transform: scale(1.05);
        }
        .qr-hint {
            position: absolute;
            bottom: -8px;
            left: 50%;
            transform: translateX(-50%);
            background: rgba(0, 0, 0, 0.7);
            color: #fff;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 11px;
            white-space: nowrap;
            opacity: 0;
            transition: opacity 0.3s ease;
            pointer-events: none;
            z-index: 2;
        }
        .qr-wrapper:hover .qr-hint {
            opacity: 1;
        }
        .qr-hint i {
            margin-right: 4px;
            font-size: 10px;
        }
      }
    }
    .footer-record{
        height: 40px !important;
        line-height: 40px !important;
        display: flex;
        margin: 0 auto;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        color: #e0e0e0;
        a {
            color: #ffffff;
            text-decoration: underline;
            transition: color 0.2s;
        }
        a:hover {
            color: #0099ff;
        }
    }
    .footer-line {
        display: inline-block;
        text-decoration: none;
        height: 20px;
        line-height: 20px;
    }
    // 响应式
    @media (max-width: 900px) {
      .footer-block {
        min-width: 0;
        padding: 0;
      }
      .foot_touch_list {
        gap: 10px;
      }
      .foot_content {
        max-width: 100vw;
        border-radius: 0;
        flex-direction: column;
        padding: 18px 8vw 0 8vw;
        gap: 18px;
        .footer-block {
          width: 100%;
          padding: 0;
          align-items: flex-start;
        }
        .weixin {
          justify-content: flex-start;
        }
      }
      .foot_touch_list {
        gap: 12px;
        justify-content: flex-start;
      }
    }
    @media (max-width: 600px) {
      .foot_touch_list {
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
      }
      .footer-record {
        font-size: 11px;
        flex-wrap: wrap;
        height: auto !important;
        line-height: 1.6 !important;
        padding: 8px 0;
      }
    }
  }
</style>